import useAxios from "axios-hooks";

export const usePasswordConfirm = () => {
    return useAxios(
        {
            url: "rlc-cliente/confirma",
            method: "POST",
        },
        { manual: true }
    );
};
